export default __webpack_public_path__ + "images/nVent_Logo.png?e370914e44268d3e8748d234ddcca4bb";